import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';

import styles from './auth-forms.css';

class RegisterModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            password2: '',
            error: '',
            busy: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange (e) {
        this.setState({[e.target.name]: e.target.value, error: ''});
    }
    handleSubmit (e) {
        e.preventDefault();
        const {username, password, password2} = this.state;
        if (!username || !password) {
            this.setState({error: 'Заполните все поля'});
            return;
        }
        if (password !== password2) {
            this.setState({error: 'Пароли не совпадают'});
            return;
        }
        if (password.length < 6) {
            this.setState({error: 'Пароль не короче 6 символов'});
            return;
        }
        this.setState({busy: true, error: ''});
        this.props.onSubmit(username, password)
            .then(() => {
                this.setState({busy: false});
                this.props.onClose();
            })
            .catch(err => {
                this.setState({busy: false, error: err.message || 'Ошибка регистрации'});
            });
    }
    render () {
        return (
            <ReactModal
                isOpen={this.props.isOpen}
                className={styles.modal}
                overlayClassName={styles.overlay}
                onRequestClose={this.props.onClose}
                contentLabel="Регистрация"
            >
                <h2 className={styles.title}>Регистрация</h2>
                <p className={styles.hint}>Без подтверждения почты — можно сразу пользоваться.</p>
                <form className={styles.form} onSubmit={this.handleSubmit}>
                    <label className={styles.label}>
                        Имя пользователя
                        <input
                            autoComplete="username"
                            className={styles.input}
                            name="username"
                            type="text"
                            value={this.state.username}
                            onChange={this.handleChange}
                        />
                    </label>
                    <label className={styles.label}>
                        Пароль
                        <input
                            autoComplete="new-password"
                            className={styles.input}
                            name="password"
                            type="password"
                            value={this.state.password}
                            onChange={this.handleChange}
                        />
                    </label>
                    <label className={styles.label}>
                        Повтор пароля
                        <input
                            autoComplete="new-password"
                            className={styles.input}
                            name="password2"
                            type="password"
                            value={this.state.password2}
                            onChange={this.handleChange}
                        />
                    </label>
                    {this.state.error ? <div className={styles.error}>{this.state.error}</div> : null}
                    <div className={styles.row}>
                        <button
                            className={styles.button}
                            disabled={this.state.busy}
                            type="submit"
                        >
                            {this.state.busy ? 'Создание…' : 'Создать аккаунт'}
                        </button>
                        <button
                            className={styles.buttonSecondary}
                            type="button"
                            onClick={this.props.onClose}
                        >
                            Отмена
                        </button>
                    </div>
                </form>
            </ReactModal>
        );
    }
}

RegisterModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default RegisterModal;
